module.exports = __webpack_public_path__ + "static/media/wave_two.8dd2164a.png";